<app-navmenu></app-navmenu>
<router-outlet></router-outlet>
